import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/roof-cleaning-ballston-spa-ny")({
  beforeLoad: () => {
    throw redirect({ to: "/roof-washing-ballston-spa-ny", statusCode: 301 });
  },
});
